// @flow

import { observer } from "mobx-react";
import React from "react";

import GlobalSettingsStore from "app/stores/GlobalSettingsStore";
import VideoStore from "app/stores/VideoStore";

import RelatedTimelines from "app/components/RelatedTimelines/RelatedTimelines";

type Props = {
    serverTime: any
};

@observer
export default class RelatedTimelinesContainer extends React.Component<Props> {
    render() {
        return (
        <RelatedTimelines
            videos={VideoStore.relatedTimelines}
            serverTime={this.props.serverTime}
            theme={GlobalSettingsStore.videoCardTheme}
             />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/containers/RelatedTimelinesContainer.js